import React from 'react';
import ReactDOM from 'react-dom';
import { ConfirmationOptions } from 'Hooks/useConfirmation';
import './ConfirmationDialog.scss';
import SlickButton from 'components/Button/SlickButton';
import { useSelector } from 'react-redux';

const ConfirmationDialog: React.FC<ConfirmationOptions & { onConfirm: () => void; onCancel: () => void }> = ({
  title = 'Confirmation',
  message = 'Are you sure?',
  iconClass = 'fa-question-circle',
  confirmLabel = 'OK',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  const theme = useSelector<AppState>(({ main: { theme } }) => theme);

  return ReactDOM.createPortal(
    <div onClick={onCancel} className={`confirm-dialog-overlay ${theme === 'dark' ? 'dark' : ''}`}>
      <div onClick={(e) => e.stopPropagation()} className="confirm-dialog-content">
        <div className="confirm-dialog-header">
          <div className="icon">
            <div className={`far ${iconClass}`}></div>
          </div>

          <div className="info">
            <h3 className="confirm-dialog-title">{title}</h3>
            <p className="confirm-dialog-description">{message}</p>
          </div>
        </div>
        <div className="confirm-dialog-footer">
          <SlickButton onClick={onCancel} btnClass="btn-outline-danger cancel-btn" tag={cancelLabel} />

          <SlickButton onClick={onConfirm} btnClass="btn-outline-success confirm-btn" tag={confirmLabel} />
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')!
  );
};

export default ConfirmationDialog;
